import sanitizeHtml from 'sanitize-html';
export const SANITIZE_PROFILE_DEFAULT = {
    allowedAttributes: Object.assign(Object.assign({}, sanitizeHtml.defaults.allowedAttributes), { a: [...sanitizeHtml.defaults.allowedAttributes.a, 'rel'], '*': ['dir'] }),
    allowedSchemes: [
        'dixa',
        'http',
        'https',
        'mailto',
        'tel',
        'callto',
        'dynamicsnav',
        'ms-dynamicsnav',
    ],
};
